import { AutomationsLaunchNudge } from "@/components/nudges/AutomationsLaunchNudge";
import { PrivacyPolicyNudge } from "@/components/nudges/PrivacyPolicyNudge";

import { AutoDeletePolicyNudge } from "@/components/nudges/AutoDeletePolicyNudge";
import { VersionUpdateNudge } from "@/components/nudges/VersionUpdateNudge";

import { cn } from "@/components/podkit/lib/cn";
import { useNudges } from "@/hooks/use-nudges";
import type { FC } from "react";
import { useLocation } from "react-router-dom";

// Note: AutoDeletePolicyNudge is intentionally NOT included in this stack.
// It is always shown at the bottom of the archive sidebar (see ArchivedSidebar.tsx) and is always lowest priority.
// This is per product requirements: it only appears when the org auto-delete policy changes.

export const Nudges: FC = () => {
    const { isPending, active } = useNudges();
    const location = useLocation();
    const isSettingsPage = location.pathname.startsWith("/settings");

    // Hide nudges when on settings pages
    const shouldHideNudges = !active || isSettingsPage;

    if (isPending) {
        return null;
    }

    return (
        <div data-testid="nudges" className={cn("flex gap-4", { hidden: shouldHideNudges })}>
            <VersionUpdateNudge />
            <PrivacyPolicyNudge />

            <AutoDeletePolicyNudge />
            <AutomationsLaunchNudge />
        </div>
    );
};
